<div class="td-wb-table-card-column" role="row">
  <div class="td-wb-table-card-column__label" role="cell">
    <ng-content select="[tdWbTableCardColumnLabel]" />
  </div>
  <div class="td-wb-table-card-column__value" role="cell">
    <ng-content select="[tdWbTableCardColumnValue]" />
  </div>
</div>
